import styled from "styled-components";
import { Badge } from "antd";

export const CandlePeopleName = styled.div`
  display: flex;
  justify-content: space-between;
  width: calc(100% - 32px);
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  margin: 16px 0;
  background: #e4d7cd;
`;

export const SmallBadge = styled(Badge)`  
  .ant-badge-count {
    padding: 2px;
    font-size: 12px;
    height: 14px;
    min-width: 14px;
    line-height: 11px;
    border: none;
    transform: translateX(13px) translateY(-7px);
  }
`;

export const candleBlurStyles: React.CSSProperties = {
  filter: "blur(10px)",
  transition: "filter 0.3s ease",
  margin: 0,
  padding: "10px",
  background: "#f0f0f0",
  borderRadius: "8px",
  textAlign: "center",
  width: "300px",
};
